const BACKEND_BASE_URL =
  process.env.REACT_APP_BACKEND_BASE_URL || 'http://flow.flickread.com:5000';
const PDF_BASE_URL = `${BACKEND_BASE_URL}/pdf`;

export { BACKEND_BASE_URL, PDF_BASE_URL };


